
( function( window, factory ) {
    // universal module definition
    /*jshint strict: false */ /* globals define, module, require */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        return factory( window );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window
        );
    } else {
        // browser global
        window.StreamVideoGroup = factory(
            window
        );
    }
}( window, function factory( window ) {
    var $ = jQuery;
        
    function StreamVideoGroup($this, _options) {
		var self = this;
        var subscribers = [];
        
		self.options = $.extend({
            ot_api_key: $this.data("api-key"),
            ot_session_id: $this.data("session-id"),
            ot_token: $this.data("token"),
            is_owner: $this.data("is-owner") == "true",
            is_inprogress: $this.data("is-inprogress") == "true",
            participant_id: $this.data("participant-id"),
            secs_to_end: parseInt($this.data("time-left-session-end"), 10),
            secs_to_start: parseInt($this.data("time-left-session-start"), 10),
            subscriber_on_videoElementCreated: null,
            subscriber_on_end_communication: null,
            on_signal: null,
            is_finished: false,
            publisher: {
                insertMode: 'append',
                width: '100%',
                height: '100%',
                // TODO: arreglar esta ref $
                name: $("#publisher").data("publisher-name"),
                style: { nameDisplayMode: "on" }
            }
        }, _options );

        self.session = OT.initSession(self.options.ot_api_key, self.options.ot_session_id);

        self.session.on('streamCreated', function streamCreated(event) {
            self.stream_created(event);
        });

        self.session.on('sessionDisconnected', function sessionDisconnected(event) {
            console.log('You were disconnected from the session.', event.reason);
        });

        /*
        OT.checkScreenSharingCapability(function(response) {
            var $share_screen_check = $("#share-screen");

            if(!response.supported || response.extensionRegistered === false) {
                // This browser does not support screen sharing.
                $share_screen_check.attr("disabled", true);
            // Esto en principio esta deprecated...
            // } else if (response.extensionInstalled === false) {
            // Prompt to install the extension.
            } else {
                // Screen sharing is available. Publish the screen.
                
                $share_screen_check.on("change", function () {
                    if ($share_screen_check.prop('checked')) {
                        self.send_signal("compartiendo pantalla " + self.options.participant_id);
                        self.publisher_screen = OT.initPublisher('publisher-screen',
                            {videoSource: 'screen'},
                            function(error) {
                                if (error) {
                                    // Look at error.message to see what went wrong.
                                    handle_ot_error(error);
                                } else {
                                    self.session.publish(self.publisher_screen, function(error) {
                                        if (error) {
                                            // Look error.message to see what went wrong.
                                            handle_ot_error(error);
                                        }
                                    });
                                }
                            }
                        );
                    } else {
                        self.send_signal("terminando de compartir pantalla " + self.options.participant_id);
                        self.publisher_screen.destroy();
                    }
                });
            }
        });
        */
       
        // initialize the publisher
        var publisherOptions = {
            insertMode: 'append',
            width: '100%',
            height: '100%',
            name: $("#publisher").data("publisher-name"),
            style: { nameDisplayMode: "on" }
        };

        self.publisher = OT.initPublisher('publisher', self.options.publisher, handle_ot_error);

        // Connect to the session
        self.session.connect(self.options.ot_token, function callback(error) {
            if (error) {
                handle_ot_error(error);
            } else {
                // If the connection is successful, publish the publisher to the session
                self.session.publish(
                    self.publisher, handle_ot_error
                );
            }
        });

        self.stream_created = function(event) {
            var subscriber = self.session.subscribe(event.stream, {insertDefaultUI: false});
            console.log(event.stream);
            subscriber.on('videoElementCreated', function(event2) {
                var cur_participant_id = get_query_param(event2.target.stream.connection.data, "participant_id");

                // TODO: Revisar si esto sirve para algo... actualmente creo que no se esta usando
                // porque no estamos seguros de que sirva
                subscriber.nicetomeet = {participant_id: cur_participant_id};
                // console.log(event2);
                // console.log(cur_participant_id);
                if (self.options.subscriber_on_videoElementCreated == null) {
                    if ($("#participant-" + cur_participant_id + " video").length == 0) {
                        document.getElementById("wrap-participant-" + cur_participant_id).appendChild(event2.element);
                        $("#participant-" + cur_participant_id).removeClass("offline").addClass("online");
                    }
                } else {
                    self.options.subscriber_on_videoElementCreated(cur_participant_id, event2, event.stream);
                }
            }).on("destroyed", on_end_communication).on("disconnected", on_end_communication);

            subscribers.push(subscriber);
        }

        self.session.on("signal", function(event) {
            var o = JSON.parse(event.data);

            if (o && o.action && !self.options.is_owner) {
                if (o.action == "mute") {
                    if (o.target == "all" || o.target == self.options.participant_id) {
                        self.publisher.publishAudio(false)
                    }
                } else if (o.action == "unmute") {
                    if (o.target == "all" || o.target == self.options.participant_id) {
                        self.publisher.publishAudio(true)
                    }
                } else if (o.action == "reload") {
                    if (o.target == "all" || o.target == self.options.participant_id) {
                        document.location.reload();
                    }
                } else if (o.action == "share-screen") {
                    if (o.target == "all" || o.target == self.options.participant_id) {
                        if (self.publisher_screen) {
                            self.send_msg_manager("El usuario ya estaba compartiendo la pantalla.", self.options.participant_id);
                        } else {
                            OT.checkScreenSharingCapability(function(response) {
                                if(!response.supported || response.extensionRegistered === false) {
                                    // This browser does not support screen sharing.
                                    self.send_msg_manager("El usuario no soporta compartir pantalla.", self.options.participant_id);
                                // Esto en principio esta deprecated...
                                // } else if (response.extensionInstalled === false) {
                                // Prompt to install the extension.
                                } else {
                                    // Screen sharing is available. Publish the screen.
                                    
                                    self.send_msg_manager("Solicitando permisos para compartir pantalla del usuario.", self.options.participant_id);
                                    self.publisher_screen = OT.initPublisher('publisher-screen',
                                        {
                                            videoSource: 'screen',
                                            publishAudio: false,
                                            showControls: false,
                                            name: "screen-share",
                                        },
                                        function(error) {
                                            if (error) {
                                                self.send_error_share(self.options.participant_id);
                                                handle_ot_error(error);
                                            } else {
                                                self.session.publish(self.publisher_screen, function(error) {
                                                    if (error) {
                                                        self.send_error_share(self.options.participant_id);
                                                        handle_ot_error(error);
                                                    } else {
                                                        self.send_msg_manager("Compartiendo pantalla.", self.options.participant_id);
                                                    }
                                                });
                                            }
                                        }
                                    );
                                }
                            });
                        }
                    }
                } else if (o.action == "unshare-screen") {
                    if (o.target == "all" || o.target == self.options.participant_id) {
                        if (self.publisher_screen) {
                            self.send_msg_manager("Terminando de compartir pantalla.", self.options.participant_id);
                            self.publisher_screen.destroy();
                        } else {
                            self.send_msg_manager("El usuario no estaba compartiendo pantalla.", self.options.participant_id);
                        }
                    }
                }
            }
        });

        if (self.options.on_signal) {
            self.session.on("signal", function(event) {
                var o = JSON.parse(event.data);
                self.options.on_signal(event, o);
            });
        }

        self.send_signal = function(data) {
            self.session.signal(
                {data: JSON.stringify(data)},
                function(error) {
                    if (error) {
                        alert_dialog("Signal ERROR (" + error.name + ")", error.message);
                        console.log(data);
                    }
                }
            );
        };

        self.send_error_share = function(participant_id) {
            self.send_msg_manager("Error compartiendo pantalla.", self.options.participant_id);

            self.send_signal({
                action: "error-share-screen",
                participant_id: participant_id
            });
        };

        self.send_msg_manager = function(message, participant_id) {
            self.send_signal({
                action: "send-msg-manager",
                message: message,
                participant_id: participant_id
            });
        };

        self.share_screen = function(participant_id) {
            self.send_signal({
                action: "share-screen",
                target: participant_id
            });
        }
        
        self.unshare_screen = function(participant_id) {
            self.send_signal({
                action: "unshare-screen",
                target: participant_id
            });
        }

        self.mute_all = function() {
            self.send_signal({
                action: "mute",
                target: "all"
            });
        }

        self.unmute_all = function() {
            self.send_signal({
                action: "unmute",
                target: "all"
            });
        }

        self.mute = function(participant_id) {
            self.send_signal({
                action: "mute",
                target: participant_id
            });
        }

        self.unmute = function(participant_id) {
            self.send_signal({
                action: "unmute",
                target: participant_id
            });
        }

        self.reload = function(participant_id) {
            self.send_signal({
                action: "reload",
                target: participant_id
            });
        }

        self.destroy = function() {
            self.publisher.destroy();
        };

        self.insert_participant_video = function(dom_participant, dom_video) {
            if (dom_participant && dom_participant.hasChildNodes()) {
                while (dom_participant.firstChild) {
                    dom_participant.removeChild(dom_participant.firstChild);
                }
            }
            
            dom_participant.appendChild(dom_video);
        }

        function on_end_communication(event) {
            // console.log("on_end_communication");
            if (self.options.subscriber_on_end_communication != null) {
                // Cuando es desconexion podemos ver los datos de la conexion anterior... si no tendremos que buscar
                // que participant se desconecto
                if (event.type == "disconnected") {
                    var cur_participant_id = get_query_param(event.target.stream.connection.data, "participant_id");
                    self.options.subscriber_on_end_communication(cur_participant_id, event);
                } else {
                    self.options.subscriber_on_end_communication(null, event);
                }
            }
        }
    }

    function handle_ot_error(error) {
        // Es muy raro pero siempre llama
        // console.log("XXXX ERROR XXXX");
        if (error) {
            console.log(error);
            // El error 1004 corresponde con un error de que el token ha caducado
            if (error.code == 1004) {
                alert_dialog("Videoconferencia terminada", "Ya ha caducado la videoconferencia.", function () {
                    document.location = N2M.HOME_URL;
                });
            // Otros errores, los sacamos por pantalla
            } else if (error.code && error.message) {
                alert_dialog("Error (" + error.code + ")", error.message);
            } else {
                alert_dialog("Error DESCONOCIDO!!!", error);
            }
        }
    }

    function get_query_param(querystring, variable) {
        var vars = querystring.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
    }

    function alert_dialog(title, message, on_hide) {
        if (window.alertDialog) {
            alertDialog.show({
                title: title,
                message: message,
                onHide: function () {
                    if (on_hide) {
                        on_hide();
                    }
                }
            });
        } else {
            console.log(title);
            console.log(message);
        }
    }

    return StreamVideoGroup;
}));

